import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import ExchangeHistoryContainer from "../../exchange/master/history/ExchangeHistoryContainer";
import ServiceBalancesWrapper from "../../serviceBalances/ServiceBalancesWrapper";
import CashFlowBalancesContainer from "./balances/CashFlowBalancesContainer";
import CashFlowTransactionsContainer from "./transactions/CashFlowTransactionsContainer";
import CashFlowBalancesHistoryContainer from "./balancesHistory/CashFlowBalancesHistoryContainer";
import CashFlowSwapContainer from "./swap/CashFlowSwapContainer";
import CashFlowProfitContainer from "./profit/CashFlowProfitContainer";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import { StyledCashFlowWrapper } from "../styledCashFlow";

const DEFAULT_TAB = "balances";

const CashFlowTabsContainer = ({ match }) => {
  const { t } = useTranslation("cashFlow");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "balances": {
        return 0;
      }
      case "balances-history": {
        return 1;
      }
      case "transactions": {
        return 2;
      }
      case "swap": {
        return 3;
      }
      case "profits": {
        return 4;
      }
      case "exchanges": {
        return 5;
      }
      case "service-balances": {
        return 6;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper>
      <StyledCashFlowWrapper>
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("tabs.balances")} value="balances"/>
            <Tab label={t("tabs.balancesHistory")} value="balances-history"/>
            <Tab label={t("tabs.transactions")} value="transactions"/>
            <Tab label="Exchangers" value="exchanges"/>
            <Tab label="Swap" value="swap"/>
            <Tab label={t("tabs.profits")} value="profits"/>
            <Tab label={t("tabs.serviceBalances")} value="service-balances"/>
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <CashFlowBalancesContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <CashFlowBalancesHistoryContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={2}
          >
            <CashFlowTransactionsContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={3}
          >
            <CashFlowSwapContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={4}
          >
            <CashFlowProfitContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={5}
          >
            <ExchangeHistoryContainer match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={6}
          >
            <ServiceBalancesWrapper />
          </TabPanel>
        </StyledTabsBody>
      </StyledCashFlowWrapper>
    </StyledContentWrapper>
  );
};

export default CashFlowTabsContainer;